import styled from "styled-components";
import { comum } from "../../../../styles/Themes/light";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 24px;
    text-align: center;
    width: 100%;

    @media (max-width: 768px) {
        padding: 40px 16px;
    }
`;

export const IconContainer = styled.div`
    margin-bottom: 20px;
    color: ${({ theme }) => theme.colors.interfaceDanger400 || comum.colors.interfaceDanger400 || '#EF4444'};
    opacity: 0.8;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Mensagem = styled.p`
    font-size: 16px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.interfaceText400 || '#6B7280'};
    line-height: 1.5;
    margin: 0 0 24px 0;
    max-width: 400px;
`;

export const BotaoRetry = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 500;
    color: ${(props: any) => props.theme.colors.pureWhite};
    background-color: ${({ theme }) => theme.colors.primaryRed400 || comum.colors.primaryRed400 || '#DC2626'};
    border: none;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.2s ease, transform 0.1s ease;

    &:hover {
        background-color: ${({ theme }) => theme.colors.primaryRed600 || comum.colors.primaryRed600 || '#B91C1C'};
    }

    &:active {
        transform: scale(0.98);
    }

    &:focus {
        outline: 2px solid ${({ theme }) => theme.colors.primaryRed400 || comum.colors.primaryRed400 || '#DC2626'};
        outline-offset: 2px;
    }

    @media (max-width: 768px) {
        width: 100%;
        max-width: 280px;
    }
`;

